class WebSocketService {

  constructor(socket) {
    this.socket = socket;
    this.subscription = null;
  }

  // constructor(channel) {
  //   this.channel = channel;
  //   this.subscription = null;
  // }

  subscribeChannel(channelName) {
    this.subscription = this.socket.channel(channelName);
  }

  listenEvent(eventName, callback) {
    this.subscription.listen(eventName, callback);
  }

  subscribePublic(eventName, callback) {
    this.subscription = this.socket.channel(this.channel).listen(eventName, callback);
  }

  subscribePrivate(channelName, eventName, callback) {
    this.subscription = this.socket.private(channelName).listen(eventName, callback);
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.stop();
      this.subscription = null;
    }
  }
}

export default WebSocketService;